import { useRef, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { useTranslation } from 'react-i18next';

import Footer from '../../components/Footer';
import PageHeader from '../../components/PageHeader';
import Pagination from '../../components/Pagination';
import HappyEndingCard from '../../components/HappyEndingCard';
import useHappyEndings from '../../hooks/useHappyEndingsList';
import Preloader from '../../components/Preloader';

function HappyEndings() {
  const { t, i18n } = useTranslation();
  const carouselRef = useRef(null);
  const { page } = useParams();
  const navigate = useNavigate();

  const currentPage = Number(page) || 1;
  const itemsPerPage = 8;

  const setCurrentPage = (newPage) => {
    const path = i18n.language === 'bs'
      ? `/happyendings/page/${newPage}`
      : `/${i18n.language}/happyendings/page/${newPage}`;
    navigate(path, { replace: false });
  };

  const { data: happyEndingsPosts = [], isLoading, error } = useHappyEndings();

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedPosts = happyEndingsPosts.slice(startIndex, endIndex);

  useEffect(() => {
    if (window.$ && carouselRef.current) {
      window.$(carouselRef.current).owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        dots: true,
        autoplay: false,
        autoplayTimeout: 4000,
        navText: [
          "<i class='fas fa-chevron-left'></i>",
          "<i class='fas fa-chevron-right'></i>",
        ],
        responsive: {
          0: { items: 1 },
          768: { items: 2 },
          992: { items: 3 },
          1200: { items: 4 },
        },
      });
    }
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [currentPage]);

  return (
    <div>
      {isLoading && <Preloader />}

      <PageHeader
        title={t('happyEndingsPage.title')}
        page={t('happyEndingsPage.page')}
        pageUrl={'/happyendings'}
      />

      <div id="blog-home" className="page">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-xl-9">
              {isLoading ? (
                <div
                  style={{
                    padding: '50px 0',
                    textAlign: 'center',
                    fontSize: '1.2rem',
                    color: '#555',
                  }}
                >
                  {t('common.loading')}
                </div>
              ) : error ? (
                <div
                  style={{
                    padding: '50px 0',
                    textAlign: 'center',
                    fontSize: '1.2rem',
                    color: 'red',
                  }}
                >
                  Error loading happy endings
                </div>
              ) : paginatedPosts.length === 0 ? (
                <div
                  className="alert alert-info mt-4"
                  style={{
                    padding: '50px 0',
                    textAlign: 'center',
                    fontSize: '1.2rem',
                    color: '#555',
                  }}
                >
                  No happy endings found
                </div>
              ) : (
                paginatedPosts.map((post, index) => (
                  <HappyEndingCard key={index} post={post} allHappyEndings={happyEndingsPosts} />
                ))
              )}

              {paginatedPosts.length > 0 && !isLoading && !error && (
                <div className="col-md-12 mt-5">
                  <Pagination
                    page={currentPage}
                    totalItems={happyEndingsPosts.length}
                    itemsPerPage={itemsPerPage}
                    onPageChange={setCurrentPage}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default HappyEndings;
